import { ArquivoAzure } from "../arquivo/ArquivoAzure";


export class PainelAtividadePsicologo {
  codigoPolo: number;
  codigoDiretoria: number;
  nomeDiretoria: string;
  /** null = URE + Escola; 0 = somente URE; >0 = escola específica (#171411). */
  codigoEscola: number | null;
  nomeEscola: string;
  codigoPsicologo?: number;
  nomePsicologo?: string;
  cpf?: string;
  dataAtividadePsicologo: Date;
  dataCheckin: Date;
  dataCheckout: Date;
  horasTrabalhadas: number;
  distancia: number;
  statusAprovacao: number;
  dataInicio: Date;
  dataFim: Date;
  timeAtividadePsicologo: string;
  descricaoAcao: string;
  tipoAcao: number;
  codigoPerfil?: number;
  nomePerfil?: string;
  codigoUsuario?: number;
  psicologosInativos: boolean;
}
